export const POIWarning = () => {
    return(
        <div className="p-3 bg-amber-50 border border-amber-200 text-sm text-amber-700 rounded-lg martrak-item-margin my-8 max-w-max">
            <i className="fa-solid fa-circle-exclamation mr-2"></i>
            This job has POIs and is currently unlocked. POIs rely on upstream and downstream sites for accurate notifications. Adding or removing AGMS/Subchains could cause notification errors.
        </div>
    )
}